module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAARtJREFUOBGVkrFOAkEYhO8M0QKegUiwNjTWFDyBFT4FFS9giKHhBTSB2EFBQ4KtL2CFhTVWFiYaE01EwOPb5NZMNrvLucnkn392Zi6XuySRk2VZA8zBGxiBklwXo4QuwBbouSyWFhfpJ23I+QezLLb9lMC3p8hIzf3pJDkQ06dwSzeQpV1iU4sWjvGd/TxN02dHj6+8Qsd5tWE8EbilpOoUvbJXAva4TPDeKevFE4FbSs7Ar5T9wE8D9rhMcCxFhj6Co3jKc0voGHwBPbfWilg3sHt0YmxrS86nzDvRr+H6+/g7MV1JKEQH/rSo5mlgFmrI9TXzRGJ+iukQTPJQaLT8aUclnYIuWHmaHtD+90UJ1MANeAHmr++Dv5IdXvy/RmhX94UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 1